module.exports = __webpack_public_path__ + "img/TAPES_new.jpg";